export default __webpack_public_path__ + "static/media/MasterCard.6e029dfb.svg";